import React, { useMemo, useState } from 'react';
import './SwotGrid.css';

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const snapToTwelve = (value) => {
  const divisions = 12;
  const step = 2 / divisions;
  const index = Math.round((value + 1) / step);
  return clamp(index * step - 1, -1, 1);
};

const toPercent = (xNorm, yNorm) => {
  const left = ((xNorm + 1) / 2) * 100 - 16 ;
  const top = (1 - (yNorm + 1) / 2) * 100 + 5;
  return { left: `${left}%`, top: `${top}%` };
};

function SwotGrid() {
  const [mockPoint] = useState({ x: 0.6, y: 0.2 });

  const snapped = useMemo(() => ({
    x: snapToTwelve(clamp(mockPoint.x, -1, 1)),
    y: snapToTwelve(clamp(mockPoint.y, -1, 1)),
  }), [mockPoint]);

  const pos = toPercent(snapped.x, snapped.y);

  const bgUrl = `${process.env.PUBLIC_URL || ''}/SWOT.png`;

  return (
    <div className="swot-wrapper">
      <div
        className="swot-grid"
        aria-label="SWOT grid"
        style={{
          backgroundImage: `url(${bgUrl})`,
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div
          className="swot-point"
          style={{ left: pos.left, top: pos.top }}
          title={`(${snapped.x.toFixed(2)}, ${snapped.y.toFixed(2)})`}
        />
      </div>
    </div>
  );
}

export default SwotGrid; 